import React from 'react';
import {
  Fab,
  Icon,
  PageContent,
  Sheet,
  Swiper,
  SwiperSlide
} from 'framework7-react';
import PropTypes from 'prop-types';

class ImageViewer extends React.Component {
  componentDidUpdate() {
    this.photoGallery.swiper.activeIndex = this.props.startPage;
    this.photoGallery.swiper.update();
  }
  render = () => {
    const { pages, startPage, onClose, opened } = this.props;

    // noinspection CheckTagEmptyBody
    return (
      <Sheet className="demo-sheet" opened={opened} style={{ height: '100%' }}>
        <PageContent>
          <div
            style={{
              height: '100%',
              width: '100%',
              left: 0,
              top: 0,
              position: 'fixed',
              backgroundColor: 'white'
            }}
          >
            <Swiper
              ref={el => {
                this.photoGallery = el;
              }}
              pagination
              navigation
              keyboard
              style={{
                height: '100%',
                width: '100%',
                backgroundColor: 'white'
              }}
              params={{
                zoom: { maxRatio: 5 },
                initialSlide: startPage,
                keyboard: {
                  enabled: true,
                  onlyInViewport: false
                },
                pagination: {
                  clickable: true,
                  renderBullet: function(index, className) {
                    return (
                      '<span class="' +
                      className +
                      '">' +
                      (index + 1) +
                      '</span>'
                    );
                  }
                }
              }}
            >
              <div slot="after-wrapper">
                <Fab
                  position="center-top"
                  slot="fixed"
                  onClick={() => {
                    this.photoGallery.swiper.zoom.in();
                  }}
                  style={{ marginLeft: -35 }}
                >
                  <Icon material="zoom_in" />
                </Fab>
                <Fab
                  position="center-top"
                  slot="fixed"
                  onClick={() => {
                    this.photoGallery.swiper.zoom.out();
                  }}
                  style={{ marginLeft: 35 }}
                >
                  <Icon material="zoom_out" />
                </Fab>
                <Fab position="right-top" slot="fixed" onClick={onClose}>
                  <Icon material="close" />
                </Fab>
              </div>
              {pages.map((url, index) => (
                <SwiperSlide
                  zoom={true}
                  key={index}
                  style={{ /*display: 'grid',*/ backgroundColor: 'white' }}
                >
                  <img
                    alt={`Page ${index}`}
                    id={`img_${index}`}
                    src={url + ''}
                    style={{
                      width: '100%',
                      maxHeight: '100%',
                      margin: 'auto'
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </PageContent>
      </Sheet>
    );
  };
}

ImageViewer.propTypes = {
  pages: PropTypes.array,
  startPage: PropTypes.number,
  opened: PropTypes.bool,
  onClose: PropTypes.func
};

export default ImageViewer;
